// removed by extract-text-webpack-plugin
module.exports = {"root":"_agC_NZDWaEGCjiqc7hPX","chartWrapper":"_21eX7T6PWkBsHkdWy_NShq","title":"_3Ek8lDGKZx901NuI88hU-j","labelKey":"_11LDrsLjqm8p02R56b9w0Q","circle":"_38CkP9lMVVKENbF-YQ68eV","labelContainer":"_1DVbCqMLOIrV0md2hLY8Py","noData":"_1hz4OdWJutx4h4r3UEmrXl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Charts/DebtPhaseEventPie/styles.css
// module id = 1056
// module chunks = 0